import stringify from 'json-stable-stringify';

import {ManagedModelType, getModelManager} from 'models/ManagedModelDefinitions';

import {BulkLookupRequest, BulkLookupResult, doLookupColumnQueryV2} from './LookupColumnsDAO';

type BulkLookupRequestKey = string;

export async function doBatchedBulkLookupColumns(
  modelKeys: Array<BulkLookupRequestKey>
): Promise<{[modelKey: BulkLookupRequestKey]: BulkLookupResult}> {
  const queries: Array<BulkLookupRequest> = modelKeys.map((modelKey) => JSON.parse(modelKey));
  const responses: Array<BulkLookupResult> = await doLookupColumnQueryV2(queries);
  const map: {[modelKey: BulkLookupRequestKey]: BulkLookupResult} = {};
  for (let i = 0; i < modelKeys.length; i++) {
    map[modelKeys[i]] = responses[i];
  }
  return map;
}

export function getBulkLookupResult(bulkRequest: BulkLookupRequest): Promise<BulkLookupResult> {
  const lookupManager = getModelManager(ManagedModelType.BULK_LOOKUP_COLUMN_RESULTS);
  return lookupManager.fetchModel(stringify(bulkRequest), {forceFetch: true});
}
